export default __webpack_public_path__ + "static/media/GreycliffCF-DemiBold.ad44fd62.ttf";